import React, { Component } from 'react';
import './App.css';

import TodoBoard from './components/TodoBoard';

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      boards: [],
      boardName: '',
      boardCounter: 0
    }
  }

  onChange = (event) => {
    this.setState({ boardName: event.target.value });
  }
  onAddBoard = (event) => {
    const { boards, boardName } = this.state;
    const valid = boardName.trim();

    if(valid && event.key === 'Enter') {
      boards.push(boardName);
      this.setState({
        boardName: '',
      });
      // console.log(boardName);
    } 
  }
  deleteBoard = (key) => {
    const { boards } = this.state;
    boards.splice(key, 1);
    this.setState({ boards });
    // console.log(boards);
  }

  render() {
    const { boards, boardName } = this.state;

    return (
      <div>
        <h1 className="appName">React Todo App</h1>

        <div className="container">
          <div className="inputGroup">
            <input className="boardInput" type="text"
              onChange={this.onChange}
              value={boardName}
              onKeyDown={this.onAddBoard}
              placeholder="Enter Todo Board Name" />
          </div>
        </div>

        <div className="boardContainer">
          {boards.map((value, key) => {
            return(
              <TodoBoard 
                key={key}
                boardName={value}
                handleDeleteBoard={() => this.deleteBoard(key)}  />
            );
          })}
        </div>

      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js